import { Button } from "@RHCommerceDev/unstyled-ui-components/Button";
import { Typography } from "@RHCommerceDev/unstyled-ui-components/Typography";
import { usePageContentNoProxy } from "@RHCommerceDev/custom-providers/LocationProvider";
import { useSetIsAuthenticationDialogAtom } from "@RHCommerceDev/hooks/atoms";
import memoize from "@RHCommerceDev/utils/memoize";
import useIsoRedirect from "hooks/useIsoRedirect";
import { useLocalization } from "hooks/useLocalization";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import sanitizeHtml from "sanitize-html";

const UpdatedPasswordWelcomePage = () => {
  const { pageContent } = usePageContentNoProxy();
  const stytchData = pageContent?.emailSignupContent;
  const prefix = useLocalization();

  const setOpenAuthenticationDialog = useSetIsAuthenticationDialogAtom();

  const handleContinueClick = e => {
    e.preventDefault();

    setTimeout(() => {
      setOpenAuthenticationDialog(false);
    }, 2000);
  };

  const form = useForm({
    defaultValues: {
      email: "",
      password: ""
    }
  });

  // iso redirect for Go to my account link
  const handleGoToMyAccount = () => {
    useIsoRedirect(
      sanitizeHtml(
        `${window?.location?.origin}${prefix}/my-account/order-history.jsp `
      ),
      "windowAssign"
    );
  };

  return (
    <div className={`grid place-content-center`}>
      <div className="flex items-center justify-center flex-col h-[232px]">
        <Typography className="mt-[30px] mb-10 text-center text-xl items-center justify-center w-full h-12 font-[75] leading-[23px] tracking-[0.4px] font-primary-rh-thin">
          {stytchData?.YOUR_PASSWORD_HAS?.split(" ").slice(0, 3).join(" ")}
          <br />
          {stytchData?.YOUR_PASSWORD_HAS?.split(" ").slice(3).join(" ")}
        </Typography>
        <FormProvider {...form}>
          <form className="items-center justify-between">
            <Button
              type="submit"
              variant="secondary"
              onClick={handleContinueClick}
              className={`mb-4 h-[48px] w-[311px]`}
            >
              {stytchData?.CONTINUE_SHOPPING}
            </Button>
          </form>
        </FormProvider>
        <div className="items-center justify-between text-center">
          <button
            className="underline underline-offset-2 p-0 w-28 h-3"
            onClick={handleGoToMyAccount}
          >
            <Typography className="text-center text-[11px] underline underline-offset-[3px] items-center justify-center font-[300] leading-[13.2px] tracking-[0.4px] font-primary-rhlight">
              {stytchData?.GO_TO_MY?.split(" ")
                .map(
                  word =>
                    word?.charAt(0).toUpperCase() + word?.slice(1).toLowerCase()
                )
                .join(" ")}
            </Typography>
          </button>
        </div>
      </div>
    </div>
  );
};

export default memoize(UpdatedPasswordWelcomePage);
